import React from 'react'
import { withPrefix } from 'gatsby'
import './conoce-nuestros-establecimientos-aliados.css'

const ConoceNuestrosEstablecimientosAliados = () => {
  return (
    <div className="ahorroYa__section-container">
      <div className="ahorroYa-partner-establishments__container-slider">
        <h2 className="ahorroYa-section__title">
          Nuestro propósito es ayudarte a alcanzar tus metas sin que te des
          cuenta
        </h2>
        <h3 className="ahorroYa-section__title ahorroYa-section__title--subtitle">
          Conoce nuestro establecimiento aliado
        </h3>
        <div className="ahorroYa-partner-establishments__container-img">
          <img
            src={withPrefix('/images/sobre-el-programa/logo-repsol.png')}
            alt="Logo Repsol"
            width="164"
          />
        </div>
      </div>
    </div>
  )
}

export default ConoceNuestrosEstablecimientosAliados
